import { render, staticRenderFns } from "./novel-reader.vue?vue&type=template&id=53c877ba&scoped=true"
import script from "./novel-reader.vue?vue&type=script&lang=js"
export * from "./novel-reader.vue?vue&type=script&lang=js"
import style0 from "./novel-reader.vue?vue&type=style&index=0&id=53c877ba&prod&lang=less"
import style1 from "./novel-reader.vue?vue&type=style&index=1&id=53c877ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c877ba",
  null
  
)

export default component.exports